import { useState } from 'react';
import { faqs } from '@/mocks/comics';
import SectionHeader from './SectionHeader';

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-3xl px-4 md:px-8">
        <SectionHeader
          kicker="常见问题"
          title="阅读之前，先了解这些"
          desc="关于阅读方式、更新节奏与功能使用的高频疑问，我们都为你整理好了。"
          align="center"
        />
        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="rounded-2xl border border-background-200 bg-background-100 overflow-hidden">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="font-semibold text-sm md:text-base text-foreground-950">{f.q}</span>
                  <i
                    className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center shrink-0 text-primary-600 transition-transform ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div
                  className="grid transition-all duration-300"
                  style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}